import React from 'react';
    import { motion } from 'framer-motion';

    const IsThisYou = () => {
      const externalLink = "https://members.sellersanonymous.org/";
      
      const personas = [
        'You\'re an experienced seller who\'s outgrown "winning at all costs"',
        'A high-integrity performer trapped in a low-integrity system',
        'A quota hitter who doesn\'t feel like a winner',
        'A salesperson optimising for the mirror, not the leaderboard'
      ];

      return (
        <section className="py-20 bg-gradient-to-br from-slate-800 to-slate-900 text-white">
          <div className="container">
            <div className="max-w-4xl mx-auto text-center">
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                whileInView={{ opacity: 1, y: 0 }} 
                viewport={{ once: true }} 
                transition={{ duration: 0.6 }}
              >
                <h2 className="text-3xl md:text-4xl font-bold mb-12">
                  Is this you?
                </h2>
                <div className="space-y-6 mb-12">
                  {personas.map((persona, index) => (
                    <motion.div 
                      key={index} 
                      initial={{ opacity: 0, x: -20 }} 
                      whileInView={{ opacity: 1, x: 0 }} 
                      viewport={{ once: true }} 
                      transition={{ delay: index * 0.1 }} 
                      className="flex items-start space-x-4 text-left max-w-2xl mx-auto"
                    >
                      <div className="w-3 h-3 bg-cyan-400 rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-slate-300 text-lg">{persona}</span>
                    </motion.div>
                  ))}
                </div>
                <motion.div 
                  initial={{ opacity: 0, y: 30 }} 
                  whileInView={{ opacity: 1, y: 0 }} 
                  viewport={{ once: true }} 
                  transition={{ duration: 0.6, delay: 0.4 }}
                >
                  <p className="text-xl text-slate-300 mb-8 font-medium">
                    If any of that sounds familiar, you'll fit right in.
                  </p>
                  <a 
                    href={externalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-white text-slate-800 hover:bg-slate-100 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-200 hover:shadow-xl hover:scale-105"
                  >
                    Join a Meeting
                  </a>
                </motion.div>
              </motion.div>
            </div>
          </div>
        </section>
      );
    };

    export default IsThisYou;